import React, { useState, createContext, useMemo } from 'react';

const DashboardContext = createContext();

const DashboardProvider = props => {
  const [dashboard, setDashboard] = useState(null);

  // Memoize the context value
  const contextValue = useMemo(() => [dashboard, setDashboard], [dashboard]);
  // eslint-disable-next-line
  return <DashboardContext.Provider value={contextValue}>{props.children}</DashboardContext.Provider>;
};

export { DashboardContext, DashboardProvider };
